/** @module csi/action/DndOrderedController */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/action/_SortOrderMixin",
	"csi/action/Controller",
	"csi/table",
	"csi/xml"
], function(declare, _, _SortOrderMixin, Controller, csiTable, xml) {

	return declare([Controller, _SortOrderMixin], {
		// Source: target of drop
		//dndTarget: null,

		// Source: source of items to drop
		//dndSource: null,

		// DOMNode[]: nodes dropped
		//dndNodes: nodes,

		/** @property {DOMNode} refNodeDragged - last of dragged refNodes */
		refNodeDragged: null,

		/** @property {DOMNode} refNodeNext - refNode following last dragged refNode */
		refNodeNext: null,

		/** @property {DOMNode} refNodeDragged - refNode preceding first dragged refNode */
		refNodePrev: null,

		/**
		 * Write operations to persist change in order
		 */
		toWriter: function() {
			// update store and query results
			var writer = this.m_writer;
			var view = this.widget;
			var qrDragged = view.getQueryResultByDomNode(this.refNodeDragged);
			var qrPrev = this.refNodePrev ? view.getQueryResultByDomNode(this.refNodePrev) : null;
			var qrNext = this.refNodeNext ? view.getQueryResultByDomNode(this.refNodeNext) : null;
			var resultUrls = qrDragged.parentResult.store.getResults();
			var ql = qrDragged.level;
			var moveAction = ql.moveAction;
			var request = moveAction && moveAction.m_request;
			var id = ql.typeSortAttribute;
			var oldGroupIds = {};

			var urls = _.map(this.dndNodes, function(domNode, i) {
				var qr = view.getQueryResultByDomNode(domNode);
				var qrParent = qr.parentResult;

				qr.moveInStore(qrNext);

				// check to see if moving between groups
				if (qrParent != qr.parentResult) {
					// the result moved from one group to another
					var newGroupValue = qr.parentResult.groupValue;
					var oldGroupValue = qrParent.groupValue;

					if (newGroupValue != oldGroupValue) {
						console.assert(qrParent.parentResult.groupValue == null, "DndOrderedController: only supports 1 group level");

						// ensure new parent is expanded
						let rowParent = view.getRefNodeById(qr.parentResult.id);
						view.setHierarchyState(rowParent, csiTable.HS_MINUS);

						if (!qrParent.getFirstChildResult()) {
							rowParent = view.getRefNodeById(qrParent.id);

							if (qrParent.isDefaultGroup()) {
								// if default group, then just collapse
								view.setHierarchyState(rowParent);
							} else {
								// delete old group if no more children
								view.deleteRow(rowParent);
							}
						}

						// TODO: maybe we can automate this based on groupSpec and its controller class (similar to drag fill?)
						view.onDndUpdateGroupValue(writer, qr, newGroupValue);

						// track which groups need refreshing
						oldGroupIds[qrParent.id] = true;
					}
				}

				return qr.url;
			});

			if (id) {
				// change sort order attribute of each url
				this._writeSortOrderValues(
					urls,
					id,
					qrPrev ? qrPrev.getResultUrl() : null,
					qrNext ? qrNext.getResultUrl() : null,
					resultUrls
				);
			} else {
				// change order of urls in refvector
				var ctx = qrDragged.getContext();
				var value = ctx.getRelationValue();
				var urlBefore = qrNext ? qrNext.getResultUrl() : null;
				var urlParent = ctx.getParentURL();
				var dropIndex;

				id = ctx.getRelationId();

				// determine indices of dragged nodes
				var dragIndices = _.map(urls, function(url) {
					return _.indexOf(value, url);
				});

				// determine index where to insert dropped nodes
				dropIndex = urlBefore ? _.indexOf(value, urlBefore) : value.length;

				this._writeDndRequest(request, urlParent, id, urls, dragIndices, dropIndex);
			}

			// refresh target and source group(s) to update counts
			if (!_.isEmpty(oldGroupIds)) {
				view.refreshParentRows(view.getRowParent(this.refNodeDragged), true);

				_.each(oldGroupIds, function(value, key) {
					view.refreshParentRows(view.getRefNodeById(key), true);
				}, this);
			}
		},

		/**
		 * Populate refNode properties
		 */
		_preAction: function() {
			if (!this.dndNodes) {
				return false;
			}

			var view = this.widget;
			this.refNodeDragged = this.dndNodes.last();
			this.refNodeNext = view.getRefNodeNext(this.refNodeDragged);
			this.refNodePrev = view.getRefNodeNext(this.dndNodes.first(), true, true);

			return this.inherited(arguments);
		},

		/**
		 * Add request to get next node in view if there are more results and assigning a sort attribute value
		 */
		_preActionRequests: function(requests) {
			this._addSortOrderRequest(this.refNodeNext, requests);
		},

		/**
		 * Write request to drag and drop urls
		 * @param {Request} request - request specified for MoveUp/MoveDown action
		 * @param {string} parentUrl - url of node owning vector attribute
		 * @param {string} parentId - id of vector attribute
		 * @param {string[]} dragUrls - urls of dragged nodes
		 * @param {number[]} dragIndices - indices in original list of dragged nodes
		 * @param {number} dropIndex - index in original list where to drop
		 */
		_writeDndRequest: function(request, parentUrl, parentId, dragUrls, dragIndices, dropIndex) {
			_.each(dragUrls, function(dragUrl, i) {
				var dragIndex = dragIndices[i];
				var toIndex = (dragIndex <= dropIndex) ? (dropIndex - 1) : dropIndex;
				if (request) {
					var call = this.m_writer.callMethod(request.m_module, request.m_operation);
					call.addParameter(xml.PROP_URL, xml.ATTR_REF, dragUrl);
					call.addParameter(xml.PROP_URL_PARENT, xml.ATTR_REF, parentUrl);
					call.addParameter(xml.PROP_ATTR_PARENT, xml.ATTR_STRING, parentId);
					call.addParameter("FromIndex", xml.ATTR_INTEGER, dragIndex);
					call.addParameter("ToIndex", xml.ATTR_INTEGER, toIndex);
				} else {
					this.m_writer.changeNode(parentUrl).moveAttributeKey(parentId, this.getParentAttributeType(), dragIndex, toIndex);
				}
				dragIndices = _.map(dragIndices, function(i) {
					if ((dragIndex > i) && (dragIndex > dropIndex)) {
						// increment drag index of future node if dragged from a higher index that that of the current dragged node
						return i + 1;
					} else if ((dragIndex < i) && (i < dropIndex)) {
						// decrement drag index of future node if current node is at a lower index and is dropped at a higher index
						return i - 1;
					}

					return i;
				});

				// update drop index if item dragged from a higher index
				if (dragIndex > dropIndex) {
					++dropIndex;
				}
			}, this);
		}
	});
});